import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

export default function ZasadyGrupowania(props) {
  return (
    <ExpandablePanel title="ZASADY GRUPOWANIA OPERACJI GOSPODARCZYCH">
      <form autoComplete="off" className="subsection">
        {props.czyPodsumowanie ? (
          <PrintText
            text={props.data.ZasadyGrupowania}
          />
        ) : (
          <TextField
            error={controlHasError(
              props.errors,
              'ZasadyGrupowania',
              props.data.ZasadyGrupowania,
            )}
            name="ZasadyGrupowania"
            label="Opis"
            multiline
            variant="outlined"
            title={props.data.ZasadyGrupowania}
            defaultValue={props.data.ZasadyGrupowania}
            onBlur={(e) =>
              props.onSetSectionData('ZasadyGrupowania', e.target.value)
            }
          />
        )}
      </form>
    </ExpandablePanel>
  )
}
